import { createFileRoute } from "@tanstack/react-router";
import TagsPage from "@/features/tags/TagsPage";
import { requireFeatureEnabled } from "@/features/features";

export const Route = createFileRoute("/_admin/knowledges/tags")({
  beforeLoad: () => requireFeatureEnabled("knowledge_base"),
  component: TagsPage,
});
